import Serializer from 'umg-ember-backend/serializers/application';

export default class JobSerializer extends Serializer {
  attrs = {
    division: 'divisionId',
    category: 'categoryId',
    asset: 'assetId',
    link: 'linkId',
  };
}
